module.exports = __webpack_public_path__ + "static/media/generic_facebook.6c653b98.jpg";